<button class="btn"  [ngClass]="'btn-' + (config?.type || type)" (click)="(config?.onClick ?? onClick)?.();">
    {{ config?.title || title }}
</button>